export function formatDate (time: any) {
    time = time * 1;
    let date = new Date(time);
    let Y = date.getFullYear();
    let m = date.getMonth() + 1;        let M = m < 10 ? ('0' + m) : m;
    let d = date.getDate();             let D = d < 10 ? ('0' + d) : d;
    let h = date.getHours();            let H = h < 10 ? ('0' + h) : h;
    let minute = date.getMinutes();     let Minute = minute < 10 ? ('0' + minute) : minute;
    let second =  date.getSeconds();    let Second = second < 10 ? ('0' + second) : second;
    return Y + "-" + M + "-" + D + " " + H + ":" + Minute + ":" + Second;
}


export function isHasBasicInfo() {
    let token = localStorage.getItem('accessToken');
    let organizationId: any = localStorage.getItem('organizationId');
    if(!token || !organizationId) {
        // Modal.error({
        //     content: '信息失效, 请重新登录!',
        //     okText: '知道了'
        // })
        return false;
    }
    else {
        return true;
    }

}
